import React from "react";
import { Switch, Route } from "react-router-dom";
import Login from "../screens/Login";
import PublicQuote from "../screens/PublicQuote";
import RecoverPassword from "../screens/RecoverPassword";

const PublicRouter = () => {
  return (
    <Switch>

      <Route path="/quotes/public/:id" exact>
        <PublicQuote />
      </Route>

      <Route path="*">
        404
      </Route>
    </Switch>
  );
};

export default PublicRouter;
